import { CreateEnrollmentType } from "../../../types/Student";
import { post } from "../../../utils/axios-config";
import { ENROLLMENTS, ENROLLMENTS_BY_STUDENT } from "../../../utils/constants";


export const createEnrollment = async (data: CreateEnrollmentType) => await post<CreateEnrollmentType, string>(ENROLLMENTS, data);

export const createEnrollmentByStudent = async (data: CreateEnrollmentType) => await post<CreateEnrollmentType, string>(ENROLLMENTS_BY_STUDENT, data);